import theme from "@/styles/theme";
import styled from "styled-components";

export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  align-self: center;
  width: 90%;
  row-gap: 2vh;
  .grid-row {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex: 2;
    column-gap: 1vw;
    @media ${theme.devices.tablet} {
      display: flex;
      flex-direction: column;
      row-gap: 2vh;
    }
  }
  @media ${theme.devices.tablet} {
    margin-bottom: 5vh;
  }
`;
